<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-notice">
            <div class="notice-header">
              <h3 class="title">
                <div class="item">
                  {{ $t('cs001.pageTitle') }}
                </div>
              </h3>
            </div>
            <div class="notice-search" v-if="userInfo.userRole !== undefined && userInfo.userRole !== 'ClubManager'">
              <div class="body">
                <div class="form">
                  <div class="select">
                    <div class="formSelect" ref="select01" @click="openSelect01">
                      <div class="formSelectList">
                        <input type="text" :value="(selectType==='') ? '' : (selectType==='ALL') ? $t('common.all') : findNoticeStatusName(selectType)" :placeholder="$t('cs001.typePlaceholder')" readonly />
                      </div>
                      <div class="formSelectPopup select01">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input type="text" :placeholder="$t('cs001.searchPlaceholder')" />
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li>
                                      <label>
                                        <input type="radio" v-model="selectedType" value="ALL" v-on:change="search"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{ $t('common.all') }}</span>
                                      </label>
                                    </li>
                                    <li>
                                      <label>
                                        <input type="radio" v-model="selectedType" value="Checking" v-on:change="search"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{ $t('cs001.checking') }}</span>
                                      </label>
                                    </li>
                                    <li>
                                      <label>
                                        <input type="radio" v-model="selectedType" value="Event" v-on:change="search"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{ $t('cs001.event') }}</span>
                                      </label>
                                    </li>
                                    <li>
                                      <label>
                                        <input type="radio" v-model="selectedType" value="Version" v-on:change="search"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{ $t('cs001.version') }}</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel">
                                      {{ $t('common.cancel') }}
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm">
                                      {{ $t('common.confirm') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="input">
                    <input type="text" v-model="searchWordValue" :placeholder="$t('cs001.searchPlaceholder')" @keyup.enter="search"/>
                  </div>
                  <div class="search" @click="search">
                    <button>
                      {{ $t('common.search') }}
                    </button>
                  </div>
                </div>
                <div class="registration" @click="moveMenu('/CS003')">
                  <button>
                    {{ $t('cs001.registerButton') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="notice-board">
              <div class="header">
                <ul class="list">
                  <li class="object">
                    {{ $t('cs001.target') }}
                  </li>
                  <li class="type">
                    {{ $t('cs001.type') }}
                  </li>
                  <li class="title">
                    {{ $t('cs001.subject') }}
                  </li>
                  <li class="writer">
                    {{ $t('cs001.writer') }}
                  </li>
                  <li class="date">
                    {{ $t('cs001.date') }}
                  </li>
                </ul>
              </div>
              <!-- 데이터 없을때(Class) : none -->
              <div class="body" :class="((noticeList1 !== null) && (noticeList1.length === 0)) ? 'none': ''">
                <ul class="list">
                  <!-- 유형 버전(Class) : typeVersion / 유형 이벤트(Class) : typeEvent / 유형 확인중(Class) : typeChecking -->
                  <!-- 비활성화(Class) : disabled -->
                  <li v-for="noticeListInfo in noticeList1" :key="noticeListInfo.account_id" @click="moveMenu('/CS002?notice_id='+noticeListInfo.notice_id)" :class="((noticeListInfo.status=='ACTIVE')&&(noticeListInfo.notice_type=='Version')) ? 'typeVersion' : ((noticeListInfo.status=='PASSIVE')&&(noticeListInfo.notice_type=='Version')) ? 'typeVersion disabled' : ((noticeListInfo.status=='ACTIVE')&&(noticeListInfo.notice_type=='Event')) ? 'typeEvent' : ((noticeListInfo.status=='PASSIVE')&&(noticeListInfo.notice_type=='Event')) ? 'typeEvent disabled' : ((noticeListInfo.status=='ACTIVE')&&(noticeListInfo.notice_type=='Checking')) ? 'typeChecking' : ((noticeListInfo.status=='PASSIVE')&&(noticeListInfo.notice_type=='Checking')) ? 'typeChecking disabled' : noticeListInfo.notice_type">
                    <div class="object">
                      <div class="item">
                        {{ (noticeListInfo.target_all_yn === 1) ? $t('common.all') : (noticeListInfo.targetInfo === '') ? $t('cs001.notEntered') : (noticeListInfo.targetInfo.length > 2) ? noticeListInfo.targetInfo : $t('cs001.golfClubCount', { n: noticeListInfo.targetInfo })}}
                      </div>
                    </div>
                    <div class="type">
                      <div class="item">
                        {{ (noticeListInfo.notice_type=='Version') ? $t('cs001.version') : (noticeListInfo.notice_type=='Event') ? $t('cs001.event') : (noticeListInfo.notice_type=='Checking') ? $t('cs001.checking') : noticeListInfo.notice_type }}
                      </div>
                    </div>
                    <div class="title">
                      <div class="item">
                        {{noticeListInfo.title}}
                      </div>
                    </div>
                    <div class="writer">
                      <div class="item">
                        {{((findAccountId(noticeListInfo.isrt_id) !== undefined) && (findAccountId(noticeListInfo.isrt_id) !== null) && (findAccountId(noticeListInfo.isrt_id) !== '')) ? findAccountId(noticeListInfo.isrt_id) : (userInfo.userName === '') ? $t('cs001.notEntered') : userInfo.userName  }}
                      </div>
                    </div>
                    <div class="date">
                      <div class="item">
                        {{(noticeListInfo.isrt_dt!=null) ? noticeListInfo.isrt_dt.substring(0,10) : $t('cs001.notEntered')}}
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="none">
                  {{ $t('cs001.noPosts') }}
                </div>
              </div>
            </div>
            <div class="notice-page">
              <!-- 이전 활성 : prevActive / 다음 활성 : nextActive -->
              <div class="paging" :class="pageClass">
                <div class="prev" @click="prevPage">
                  <div class="item">
                    {{ $t('cs001.prev') }}
                  </div>
                </div>
                <ul class="number" v-for="index in pageArray" :key="index">
                  <!-- 활성 : active -->
                  <li :class="index == pageNo? 'active': ''" @click="getPage(index)">
                    {{ index }}
                  </li>
                </ul>
                <div class="next" @click="nextPage">
                  <div class="item">
                    {{ $t('cs001.next') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="notice-more">
              <div class="more" v-if="pageNo < noticeCnt/pageSize" @click="moreMobileData" >
                {{ $t('cs001.more') }}
              </div>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body">
                    {{ $t('cs001.replyAlert1') }}<br />
                    {{ $t('cs001.replyAlert2') }}<br />
                    {{ $t('cs001.replyAlert3') }}
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <button class="confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {aplManagerService, clubInfoService, userService} from '../../router'

export default {
  name: 'CS001',
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  data () {
    return {
      paramStatus: '',
      paramAuthority: '',
      paramselectType: '',
      paramPageNo: 1,
      paramPageSize: 10,
      selectedType: '',
      doneindex: 0,
      fetched: 'false',
      clubInfoList: [],
      clubString: '',
      clubTargets: [],
      accountInfoList: [],
      noticeListUserIds: [],
      noticeListRoles: [],
      noticeListNames: [],
      noticeListIds: [],
      noticeList1: null,
      loading: true,
      orderTarget: '',
      orderValue: '',
      searchWordValue: '',
      selectType: '',
      selectValue: '',
      search_type: '',
      sortColumn: '',
      sortType: '',
      pageNo: 1,
      pageIndex: 0,
      pageSize: 10,
      pageBuffer: 5,
      noticeCnt: 0,
      noticeList: null,
      search_word: '',
      accountUserInfo: [],
      account_id: '',
      user_id: '',
      status: '',
      user_name: '',
      user_role: '',
      user_phone: '',
      user_email: '',
      ccode: '',
      CustomerNoticeInfoList: []
    }
  },
  created: function () {
    window.addEventListener('resize', this.resizeEvt)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.resizeEvt)
  },
  mounted: function () {
    document.querySelector('body.type-content').classList.remove('select01Active')
    userService.getAll().then(response => {
      this.userInfo = response.data
      if (this.userInfo.userRole === 'ClubManager') {
        document.querySelector('body.type-content').classList.add('loginClub')
        Promise.all([clubInfoService.getClubInfoList('active'), aplManagerService.getCustomerNoticeListView(this.paramPageNo, this.paramPageSize, this.paramselectType, this.searchWordValue)])
          .then(response => {
            this.clubInfoList = response[0].data.clubInfoList
            this.CustomerNoticeInfoList = response[1].data
            this.noticeCnt = this.CustomerNoticeInfoList.noticeCnt
            this.noticeList1 = this.CustomerNoticeInfoList.noticeList
          }).catch(error => {
            console.log('getCustomerNoticeTargetsNoticeId.err.===>', error)
          })
      } else {
        Promise.all([aplManagerService.getSummaryManagementUserListView(this.orderTarget, this.orderValue, this.paramStatus, this.paramAuthority, this.search_word), clubInfoService.getClubInfoList('active'), aplManagerService.getCustomerNoticeListView(this.paramPageNo, this.paramPageSize, this.paramselectType, this.searchWordValue)])
          .then(response => {
            this.accountInfoList = response[0].data.accountList
            this.clubInfoList = response[1].data.clubInfoList
            this.CustomerNoticeInfoList = response[2].data
            this.noticeCnt = this.CustomerNoticeInfoList.noticeCnt
            this.noticeList1 = this.CustomerNoticeInfoList.noticeList
          }).catch(error => {
            console.log('getCustomerNoticeTargetsNoticeId.err.===>', error)
          })
      }
    })
  },
  methods: {
    resetSearchParams: function () {
      this.pageNo = 1
      this.pageIndex = 0
      this.paramPageNo = 1
      this.paramPageSize = 10
      this.paramStatus = ''
      this.paramAuthority = ''
      this.paramselectType = ''
      this.selectType = ''
      this.selectedType = ''
      this.searchWordValue = ''
    },
    resizeEvt: function () {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          this.resetSearchParams()
          this.setData()
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          this.resetSearchParams()
          this.setData()
        }
      }
    },
    findAccountId: function (accountId) {
      if (this.accountInfoList.find(it => it.account_id === accountId) !== undefined) {
        return this.accountInfoList.find(it => it.account_id === accountId).user_name
      } else {
        return ''
      }
    },
    moreMobileData: function () {
      this.pageNo += 1
      this.paramPageNo = this.pageNo
      aplManagerService.getCustomerNoticeListView(this.paramPageNo, this.paramPageSize, this.paramselectType, this.searchWordValue).then(response => {
        this.noticeCnt = response.data.noticeCnt
        this.noticeList1 = this.noticeList1.concat(response.data.noticeList)
      })
    },
    findNoticeStatusName: function (status) {
      if (this.statusNoticeTypeList.find(it => it.statusCode === status) !== undefined) {
        return this.statusNoticeTypeList.find(it => it.statusCode === status).statusName
      } else {
        return ''
      }
    },
    nextPage: function () {
      if (this.pageIndex >= this.pageIndexMax) return
      this.pageIndex++
      this.move_another_page(this.pageArray[0])
    },
    prevPage: function () {
      if (this.pageIndex <= 0) return
      this.pageIndex--
      this.move_another_page(this.pageArray[this.pageArray.length - 1])
    },
    getPage: function (index) {
      this.pageNo = index
      this.paramPageNo = index
      this.setData()
    },
    move_another_page: function (index) {
      this.pageNo = index
      this.paramPageNo = index
      this.setData()
    },
    search: function () {
      this.pageNo = 1
      this.pageIndex = 0
      this.paramPageNo = 1
      this.paramPageSize = 10
      this.setData()
    },
    setData: function () {
      // alert(this.search_word)
      this.selectType = this.selectedType
      this.paramselectType = this.selectType
      if (this.paramselectType === 'ALL') this.paramselectType = ''
      aplManagerService.getCustomerNoticeListView(this.paramPageNo, this.paramPageSize, this.paramselectType, this.searchWordValue).then(response => {
        this.CustomerNoticeInfoList = response.data
        this.noticeList1 = this.CustomerNoticeInfoList.noticeList
        this.noticeCnt = this.CustomerNoticeInfoList.noticeCnt
      }).catch(error => {
        console.log('getCustomerNoticeListView.err.===>', error)
      })
    }
  },
  computed: {
    statusNoticeTypeList: function () {
      return [
        {
          statusCode: 'Checking',
          statusName: this.$t('cs001.checking')
        },
        {
          statusCode: 'Event',
          statusName: this.$t('cs001.event')
        },
        {
          statusCode: 'Version',
          statusName: this.$t('cs001.version')
        }
      ]
    },
    pageArray: function () {
      if (this.noticeCnt <= 0) return [1]
      let pageMax = Math.floor((this.noticeCnt - 1) / this.pageSize) + 1
      let arr = []
      for (let i = 1; i <= this.pageBuffer; i++) {
        let j = this.pageIndex * this.pageBuffer + i
        if (j > pageMax) break
        arr.push(j)
      }
      return arr
    },
    pageIndexMax: function () {
      return Math.floor((this.noticeCnt - 1) / (this.pageSize * this.pageBuffer))
    },
    pageClass: function () {
      return {
        nextActive: this.pageIndex < this.pageIndexMax,
        prevActive: this.pageIndex > 0
      }
    }
  },
  watch: {
    pageIndex: function (val) {
      this.pageIndex = val < 0 ? 0 : val > this.pageIndexMax ? this.pageIndexMax : val
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cs/CS001.vue